<div class="modal-header">
  <button
    class="modal-close"
    (click)="close(false)"
    [attr.data-qa]="closeButtonQaId?.getButtonId()"
  >
    <app-svg iconName="CloseBig"></app-svg>
  </button>
</div>
<div class="modal-body row">
  <div class="col mb-5">
    <div class="h2 modal-headline mb-5">{{ 'habaAddressMelissa.heading' | cxTranslate }}</div>
    <form (ngSubmit)="onSubmit($event)" [formGroup]="form">
      <p class="mb-6">{{ 'habaAddressMelissa.paragraph' | cxTranslate }}</p>
      <div class="mb-10">
        <div class="mb-6">
          <p class="mb-4">
            <strong>{{ 'habaAddressMelissa.suggestions' | cxTranslate }}</strong>
          </p>
          <div *ngFor="let fixed of address.fixedAddresses; let index = index">
            <app-form-radio>
              <input appFormInput type="radio" [value]="index" formControlName="addressIndex" />
              <app-form-label>
                <ng-container
                  *ngTemplateOutlet="addressDisplay; context: { $implicit: fixed }"
                ></ng-container>
              </app-form-label>
            </app-form-radio>
          </div>
        </div>
        <div>
          <p class="mb-4">
            <strong>{{ 'habaAddressMelissa.yourInput' | cxTranslate }}</strong>
          </p>
          <div>
            <app-form-radio>
              <input appFormInput type="radio" [value]="-1" formControlName="addressIndex" />
              <app-form-label>
                <ng-container
                  *ngTemplateOutlet="addressDisplay; context: { $implicit: address }"
                ></ng-container>
              </app-form-label>
            </app-form-radio>
          </div>
        </div>
      </div>
      <button appButton type="submit" [fullWidth]="true">
        {{ 'habaAddressMelissa.submitButton' | cxTranslate }}
      </button>
    </form>
  </div>
</div>
<ng-template #addressDisplay let-addr>
  <span data-name="line1">{{ addr.line1 }} </span>
  <span data-name="street-number">{{ addr.line2 }}</span>
  <br />
  <span data-name="zip">{{ addr.postalCode }} </span>
  <span data-name="town">{{ addr.town }}</span>
</ng-template>
